"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base = exports.optimism = exports.arbitrum = exports.ethereum = exports.bob = exports.bsquared = exports.bsc = exports.polygon = void 0;
exports.polygon = {
    mainnet: {
        WrappedNativeToken: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
        DAIAddress: "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
        USDTAddress: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
        USDC_EAddress: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
        USDCAddress: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359",
        WBTCAddress: "0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6",
        SANDAddress: "0xBbba073C31bF03b8ACf7c28EF0738DeCF3695683",
        WBNBAddress: "",
        WETHAddress: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
        WMATICAddress: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
    },
    testnet: {
        WrappedNativeToken: "0x0ae690aad8663aab12a671a6a0d74242332de85f",
    },
};
exports.bsc = {
    mainnet: {
        WrappedNativeToken: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
        USDTAddress: "0x55d398326f99059fF775485246999027B3197955",
        USDC_EAddress: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
        WBNBAddress: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
        WETHAddress: "0x5DA5DA6933637c1cAfa5de9FdF2aCb1B3758C9e3",
        BTCBAddress: "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
        TEST_TSTAddress: "0x86Bb94DdD16Efc8bc58e6b056e8df71D9e666429",
    },
    testnet: {
        WrappedNativeToken: "",
        WBNBAddress: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd",
        WETHAddress: "0xd66c6B4F0be8CE5b39D52E0Fd1344c389929B378",
    },
};
exports.bsquared = {
    mainnet: {
        WrappedNativeToken: "0x4200000000000000000000000000000000000006",
        USDTAddress: "0x681202351a488040Fa4FdCc24188AfB582c9DD62",
        USDC_EAddress: "0xe544e8a38add9b1abf21922090445ba93f74b9e5",
        WBTCAddress: "0x4200000000000000000000000000000000000006",
    },
    testnet: {
        WrappedNativeToken: "",
    },
};
exports.bob = {
    mainnet: {
        WrappedNativeToken: "0x03C7054BCB39f7b2e5B2c7AcB37583e32D70Cfa3",
        USDTAddress: "0x05D032ac25d322df992303dCa074EE7392C117b9",
        USDC_EAddress: "0xe75D0fB2C24A55cA1e3F96781a2bCC7bdba058F0",
        WETHAddress: "0x4200000000000000000000000000000000000006",
        WBTCAddress: "0x03C7054BCB39f7b2e5B2c7AcB37583e32D70Cfa3",
    },
    testnet: {
        WrappedNativeToken: "",
    },
};
exports.ethereum = {
    mainnet: {
        WrappedNativeToken: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        USDTAddress: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        USDCAddress: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        WETHAddress: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        WMATICAddress: "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0",
        WBTCAddress: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
    },
    testnet: {
        WrappedNativeToken: "",
    },
};
exports.arbitrum = {
    mainnet: {
        WrappedNativeToken: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        USDTAddress: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
        USDCAddress: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
        WETHAddress: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        WMATICAddress: "0x561877b6b3DD7651313794e5F2894B2F18bE0766",
        WBTCAddress: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
    },
    testnet: {
        WrappedNativeToken: "",
    },
};
exports.optimism = {
    mainnet: {
        WrappedNativeToken: "0x4200000000000000000000000000000000000006",
        USDTAddress: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58",
        USDCAddress: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
        WETHAddress: "0x4200000000000000000000000000000000000006",
        WBTCAddress: "0x68f180fcCe6836688e9084f035309E29Bf0A2095",
    },
    testnet: {
        WrappedNativeToken: "",
    },
};
exports.base = {
    mainnet: {
        WrappedNativeToken: "0x4200000000000000000000000000000000000006",
        USDCAddress: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        WETHAddress: "0x4200000000000000000000000000000000000006",
    },
    testnet: {
        WrappedNativeToken: "",
    },
};
//# sourceMappingURL=tokens-info.js.map